// Disparo de conversões do Google Ads (gtag injetado em shared/_google_ads.html.erb).
// Se a env GOOGLE_ADS_ID não estiver setada, window.GADS/window.gtag não existem
// e as funções viram no-op — seguro em dev e enquanto o tracking não estiver configurado.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    GADS?: { id: string; signupLabel?: string; purchaseLabel?: string }
    GA4_ID?: string
  }
}

// Pageview do GA4 nas navegações da SPA (react-router não recarrega a página).
// Enviado só para o GA4 (send_to) para não poluir o Google Ads.
export function trackPageview(path: string): void {
  const id = window.GA4_ID
  if (!window.gtag || !id) return
  window.gtag("event", "page_view", {
    send_to: id,
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  })
}

export function trackSignup(): void {
  const g = window.GADS
  if (!window.gtag || !g?.id || !g.signupLabel) return
  window.gtag("event", "conversion", {
    send_to: `${g.id}/${g.signupLabel}`,
  })
}

export function trackPurchase(valueBRL: number, transactionId: number | string): void {
  const g = window.GADS
  if (!window.gtag || !g?.id || !g.purchaseLabel) return
  window.gtag("event", "conversion", {
    send_to: `${g.id}/${g.purchaseLabel}`,
    value: valueBRL,
    currency: "BRL",
    transaction_id: String(transactionId),
  })
}
